export default {
    pricing: {
        titleHK: '香港訂立平安紙服務 | 價目',
        descriptionHK: '單一份平安紙由 1,500 港元，夫妻各一份平安紙由 2,250 港元。 查看價目和網上平安紙服務有關的其他詳情。',
        keywordsHK: '香港平安紙費用,網上平安紙價錢,遺產計劃價格,會籍',
        whatIsThe: '平安紙的',
        pricing: '價格',
        forAWill: '',
        pricingStarts: '價格由',
        andIncludes: '起，修改費用由{{membership}}開始。',
        perJurisdiction: '每個司法管轄區',
        oneTimeBundlePrice: '一次性組合價格',
        forCouples: ' 夫妻組合',
        coupleSavings: '節省{{savings}}',
        start: '免費開始',
        more: '關於網上平安紙',
        keep: '記得定時更新平安紙',
        upToDate: '',
        membership1:
            '生活環境變化無常，你的平安紙也應隨著時間而修改及更新。只需成為會員，便可隨時登入無限次修改你的平安紙。 對比起傳統的律師樓和平安紙公司所收的昂貴費用合理得多， 首年免費，其後每年{{price}}。',
        membership2: '',
        faq: '關於價格常見問題',
        package: '網上遺產計劃',
        onlineWills: '網上平安紙',
        onlineWill: '網上遺囑',
        onlineWillDescription: '只需 15 分鐘即可在網上訂立遺囑，並在需要時獲得指導。',
        estatePlanningBundle: '遺產規劃組合',
        estatePlanningBundleDescription: '包括專家遺產規劃諮詢、專業查閱、身份驗證，以及海外資產的額外指導。',
        pricingSectionEyebrow: '價格',
        pricingSectionTitle: '選擇您希望如何完成平安紙',
        pricingSectionDescription: '先在網上完成您的平安紙。準備就緒後，您可選擇只購買平安紙，或加入專業指引及查閱。',
        pricingSectionDescription_printing: '先在網上完成您的平安紙。準備就緒後，您可選擇只購買平安紙，或加入專業指引、查閱及印刷支援。',
        pricingSectionDescription_signing: '先在網上完成您的平安紙。準備就緒後，您可選擇只購買平安紙，或加入專業指引、查閱及簽署支援。',
        pricingSectionDescription_printingAndSigning: '先在網上完成您的平安紙。準備就緒後，您可選擇只購買平安紙，或加入專業指引、查閱、印刷及簽署支援。',
        pricingSectionCtaNote: '完成平安紙前無需付款。請在結帳時選擇您希望的支援程度。',
        onlineWillJourneyTitle: '網上平安紙',
        onlineWillJourneyDescription: '適合能夠自行完成及簽署平安紙的人士。',
        onlineWillJourneyPriceHeading: '價格',
        onlineWillExpertSupport: '網上平安紙 + 專業支援',
        onlineWillExpertSupportDescription: '適合希望獲得個人指引及專業查閱的人士。',
        onlineWillExpertSupportDescription_printing: '適合希望在查閱及印刷過程中獲得個人指引和實務支援的人士。',
        onlineWillExpertSupportDescription_signing: '適合希望在查閱及簽署過程中獲得個人指引和實務支援的人士。',
        onlineWillExpertSupportDescription_printingAndSigning: '適合希望在查閱、印刷及簽署過程中獲得個人指引和實務支援的人士。',
        selfGuided: '自行完成',
        moreSupport: '更多支援',
        oneJurisdictionSpecificWill: '一份平安紙',
        includesOneJurisdictionSpecificWill: '一份平安紙 + 一次性專業支援',
        everythingInOnlineWillPlus: '包括網上平安紙的所有內容，另加：',
        automatedConsistencyChecks: '內容一致性檢查',
        inPersonWitnessingAppointment: '親身簽署及見證預約',
        multiCountryAlertBody: '如選擇為多於一個國家或地區訂立遺囑，每份遺囑須分開購買。',
        multiCountryExpertSupport:
            '如選擇加購「專業支援服務」，只需加購一次；凡於規劃會議提供之前所購買的其他遺囑，均可一併涵蓋於同一次「專業支援服務」之內。「專業支援服務」一經使用即告完成。日後如有需要，可選擇以優惠價再次加購。',
        multiCountryExpertSupport_printing:
            '如選擇加購「專業支援服務」，只需加購一次；凡於規劃會議及專業印刷服務提供之前所購買的其他遺囑，均可一併涵蓋於同一次「專業支援服務」之內。「專業支援服務」一經使用即告完成。日後如有需要，可選擇以優惠價再次加購。',
        multiCountryExpertSupport_signing:
            '如選擇加購「專業支援服務」，只需加購一次；凡於規劃會議及見證服務提供之前所購買的其他遺囑，均可一併涵蓋於同一次「專業支援服務」之內。「專業支援服務」一經使用即告完成。日後如有需要，可選擇以優惠價再次加購。',
        multiCountryExpertSupport_printingAndSigning:
            '如選擇加購「專業支援服務」，只需加購一次；凡於規劃會議、專業印刷及見證服務提供之前所購買的其他遺囑，均可一併涵蓋於同一次「專業支援服務」之內。「專業支援服務」一經使用即告完成。日後如有需要，可選擇以優惠價再次加購。',
        temporaryGuardianshipDescription: '指定臨時監護人',
        whatsIncluded: '包含',
        availableAddons: '可選附加服務',
        idealFor: '適合',
        single: '單一份平安紙',
        couple: '夫婦各一份平安紙',
        willIncludes1: '1 份按司法管轄區訂立的平安紙文件',
        willIncludes2: '致執行人/受託人的信函（通知他們被委任了）',
        willIncludes3: '願望信',
        willIncludes4: '資產與數碼資產清單',
        willIncludes5: '所有文件的PDF版本',
        willIncludes6: '30日在平台上進行無限次更改',
        willIncludes7: '專業印刷版本送到府上',
        willIncludes8: '為您的平安紙和資產清單進行專業查閱',
        willIncludes9: '30分鐘網上遺產規劃諮詢',
        willIncludes10: '指定永久監護人',
        willIncludes11: '自行簽署見證指示',
        willIncludes12: '遺囑一致性審查',
        willIncludes13: '「網上遺囑」服務的所有內容',
        willIncludes14: '身份驗證',
        willIncludes15: '安排見證',
        willIncludes16: '海外資產及多項司法管轄權的額外指導',
        editingMembership: '會籍',
        membership: '會籍',
        membershipIncludes1: '無限次對您的平安紙進行修改',
        membershipIncludes2: '由我們的遺囑專家對每次的更新提交進行查閱',
        membershipIncludes3: '持續支援',
        membershipIncludes4: '通知您們有關的法律的變更。',
        witnessing: '見證服務',
        print: '專業印刷版本',
        storageService: '平安紙保管服務',
        countrySpecificWills: '其他國家平安紙',
        discount: '折扣',
        fixedDiscount: '扣減{{currency}}{{discount}}',
        percentDiscount: '{{discount}}%優惠',
        autoApply: '折扣將會自動在結帳時使用。',
        onlineWillFootnote: '如需要多於一個國家的平安紙，可另外加購其他國家的平安紙。',
        estatePlanningBundleFootnote: '遺產規劃組合是一次性套裝，包括一份平安紙及額外服務。其他國家的平安紙可另外加購。',
    },
};
